<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-11-15 13:09:14
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-06-23 13:03:54
 * @Description: 计划付款
 * @FilePath: \ICPSxin\src\views\platform\ICPS\GHnumber\payment\planForPayment
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="display: inline-block; margin-bottom: 0.625rem">
                <span style="margin-right: 0.75rem">付款时间</span>
                <el-date-picker
                  v-model="startTimDateEndTimDate"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  start-placeholder="请选择 起止日期"
                  end-placeholder="结束时间"
                  @change="(tableParam.startTime = startTimDateEndTimDate[0] || ''), (tableParam.endTime = startTimDateEndTimDate[1] || '')"
                ></el-date-picker>
              </span>
              <span style="margin-left: 0.75rem">
                <span style="margin-right: 0.75rem">付款方式</span>
                <el-select v-model="tableParam.paymentMethod" style="width: 200px" placeholder="请选择" clearable>
                  <el-option v-for="item in billTypeList" :key="item.id" :label="item.itemName" :value="item.itemName"></el-option>
                </el-select>
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" style="margin-left: 1.5rem" @click="gettableData()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 0.75rem" @click="init()">重 置</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav" style="height: 45px">
            <div>
              <el-button size="small" class="bottom_all" style="margin-left: 0" @click="addFromDate('添加/编辑')"> 添 加</el-button>
              <el-button size="small" class="bottom_two" style="margin-left: 10px" @click="exportDialog=true"> 导 入 </el-button>
              <el-button size="small" class="bottom_three" style="margin-left: 12px" @click="load()">导 出</el-button>
            </div>
            <div>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 1.25rem">
                <el-link :underline="false">
                  <span class="el-icon--left">
                    <i class="iconfont iconicon_button_filtrate"></i>
                  </span>筛选
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in table" :key="index">
                    <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :height="screenHeight - 450" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width" :prop="item.prop">
                  <template slot-scope="scope">
                    <span v-if="item.label == '操作'">
                        <el-button size="mini" style="margin: 0.3125rem 0" class="bottom_one" @click="updateFromDate(scope.row, '添加/编辑')">修改</el-button>
                        <el-button size="mini" style="margin: 0.3125rem 0.2rem" class="bottom_one" @click="DelItem(scope.row)">删除</el-button>
                    </span>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>

    <el-dialog v-dialogDrag :visible.sync="addDialog" width="760px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo" style="padding: 10px 30px;">
        <el-form ref="reffromDate" :rules="rules" :model="fromDate" label-width="120px" label-position="left">
          <el-form-item label="计划付款时间" prop="planPaymentDate" style="display: block; margin-bottom: 18px;">
            <el-date-picker v-model="fromDate.planPaymentDate" type="date" value-format="yyyy-MM-dd" style="width: 100%" placeholder="请选择"></el-date-picker>
          </el-form-item>
          <el-form-item label="类型" prop="payType" style="display: block; margin-bottom: 18px;">
            <el-select v-model="fromDate.payType" style="width: 100%" placeholder="请选择" @change="handlePayTypeChange">
              <el-option label="现金" value="现金"></el-option>
              <el-option label="票据" value="票据"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款方式" prop="paymentMethod" style="display: block; margin-bottom: 18px;">
            <el-select v-model="fromDate.paymentMethod" style="width: 100%" placeholder="请选择" filterable clearable>
              <el-option v-for="item in billTypeList" :key="item.itemName" :label="item.itemName" :value="item.itemName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="票号" prop="ticketNo" style="display: block; margin-bottom: 18px;">
            <el-select v-model="fromDate.ticketNo" style="width: 100%" placeholder="请选择" filterable clearable :disabled="fromDate.payType === '现金'">
              <el-option v-for="(item, index) in ticketNoList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商类别" prop="supplierType" style="display: block; margin-bottom: 18px;">
            <el-select v-model="fromDate.supplierType" style="width: 100%" placeholder="请选择" filterable clearable>
              <el-option v-for="item in supplierCategoryList" :key="item.id" :label="item.itemName" :value="item.itemName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付合同编号" prop="contractNumber" style="display: block; margin-bottom: 18px;">
            <el-select v-model="fromDate.contractNumber" style="width: 100%" placeholder="请选择" filterable clearable  @change="handleContractChange">
              <el-option v-for="(item, index) in contractData" :key="index" :label="item.contractNumber" :value="item.contractNumber"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="供应商名称" prop="supplierName" style="display: block; margin-bottom: 18px;">
            <el-select v-model="fromDate.supplierName" style="width: 100%" placeholder="自动带入" disabled>
              <el-option v-for="item in supplierList" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="计划金额" prop="planPaymentAmount" style="display: block; margin-bottom: 18px;">
            <el-input v-model="fromDate.planPaymentAmount" style="width: 100%" placeholder="请输入" clearable />
          </el-form-item>

        </el-form>
      </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
          <el-button class="bottom_all" style="margin-left: 24px" @click="submit()">保 存</el-button>
        </span>
    </el-dialog>

    <el-dialog v-dialogDrag :visible.sync="exportDialog" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">导入付款计划信息</span>
      <div v-loading="loading" element-loading-text="数据解析中..." element-loading-background="rgba(0, 0, 0, 0.8)" class="dialoginfo" style="text-align: center">
        <el-upload class="upload-demo" :on-success="fileSuccess" :before-upload="filebefore" :show-file-list="false" drag action="/icps/system/sign/dataCollection/planPayment/importList" name="file" :headers="upheader">
          <i slot="trigger" class="el-icon-upload"></i>
          <div slot="trigger" class="el-upload__text">
            将文件拖到此处，或
            <em>点击选取文件</em>
          </div>
        </el-upload>
        <div style="padding-top: 10px">
          <el-button class="bottom_all" style="margin-left: 0" @click="importSubmit()">下载模板</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="exportDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, Download,batchDelPlanPay, queryContractNumber, savePlanPay } from "@/api/internetSales/planForPayment.js";
import { getToken, getUserId } from "@/utils/auth";
import { get_detail_code } from "@/api/GHnumber/procurement.js";
import { selectTicketList } from "@/api/GHnumber/payment.js";
import { querysupplierPage } from "@/api/GHnumber/supplier.js";

export default {
  mixins: [mixin],
  data() {
    return {
      exportDialog: false,
      loading: false,
      tableLoading: false, 
      tableData: [],       
      total: 0,            
      upheader: {
        "access-token": getToken(),
        "user-id": getUserId(),
      },
      DownloadURL: Download,
      startTimDateEndTimDate: [],
      tableParam: {
        page: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        paymentMethod: "" 
      },
      table: [
        { label: "计划付款时间", width: "120", prop: "planPaymentDate", status: true },
        { label: "类型", width: "100", prop: "payType", status: true },
        { label: "票号", width: "180", prop: "ticketNo", status: true },
        { label: "付款方式", width: "140", prop: "paymentMethod", status: true },
        { label: "付款行及金融工具", width: "160", prop: "authBank", status: true },
        { label: "票据类型", width: "130", prop: "ticketType", status: true },
        { label: "供应商类别", width: "120", prop: "supplierType", status: true },
        { label: "供应商名称", width: "160", prop: "supplierName", status: true },
        { label: "支付合同编号", width: "140", prop: "contractNumber", status: true },
        { label: "支付合同主体", width: "160", prop: "contractSignSubject", status: true },
        { label: "计划金额", width: "120", prop: "planPaymentAmount", status: true },
        { label: "操作", width: "120", prop: "", status: true },
      ],
      rules: {
        planPaymentDate: [{ required: true, message: "请输入计划付款时间", trigger: "change" }],
        payType: [{ required: true, message: "请选择类型", trigger: "change" }],
        planPaymentAmount: [{ required: true, message: "请输入计划金额", trigger: "blur" }],
        paymentMethod: [{ required: true, message: "请选择付款方式", trigger: "change" }],
        contractNumber: [{ required: true, message: "请选择支付合同编号", trigger: "change" }]
      },
      fromDate: {
        id: "",
        planPaymentDate: "",    
        payType: "",            
        ticketNo: "",           
        paymentMethod: "",      
        authBank: "",           
        ticketType: "",         
        supplierType: "",       
        supplierId: "",         
        supplierName: "",       
        contractNumber: "",     
        planPaymentAmount: "",  
        contractSignSubjectId: "", 
        contractSignSubject: "",   
      },
      
      billTypeList: [],
      ticketNoList: [], 
      supplierCategoryList: [], 
      supplierList: [], 
      contractData: [],
    };
  },
  created() {
    this.tableParam = { 
        ...this.tableParam, 
        startTime: "", 
        endTime: "", 
        paymentMethod: "", 
    };
    this.gettableData();
    
    get_detail_code({ codes: "SHOUKUANXINGSHI,ICPS_FinancialSupplierCategory" }).then(res => {
      if (res.code == 1001) {
        this.billTypeList = res.data["SHOUKUANXINGSHI"].items;
        this.supplierCategoryList = res.data["ICPS_FinancialSupplierCategory"].items;
      }
    });

    selectTicketList().then(res => {
      var arr = [...new Set([...res.data])];
      this.ticketNoList = arr.filter(e => e && e.trim());
    });

    querysupplierPage({ page: 1, pageSize: 99999, enable: 1 }).then(res => {
      if (res.code === 1001) {
        this.supplierList = res.data.data
      }
    });
    this.getContractData()
  },
  methods: {
    gettableData() {
      this.tableLoading = true;
      queryPage(this.tableParam).then(res => {
        if (res.code === 1001) {
          this.tableData = res.data.data || []; 
          this.total = res.data.totalRows || 0; 
        } else {
          this.$message.error(res.codeMsg || "查询失败！");
        }
        this.tableLoading = false;
      });
    },

    importSubmit(){
      window.open("https://lvshe.huashijc.com/file/group1/M01/74/EB/ChQACmo6E5aACt0eAADR4J0W6s067.xlsx");
    },
    
    filebefore(file) {
      this.loading = true;
      const isXlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isXlsx) {
        this.$message.error("数据上传必须是 xlsx 格式!");
        this.loading = false;
      }
      return isXlsx;
    },

    fileSuccess(res) {
      this.loading = false;
      if (res.code == 1001) {
        this.$message.success("解析成功！");
        this.exportDialog = false;
        this.gettableData();
      } else {
        this.$message.error(res.codeMsg);
      }
    },

    init() {
      this.tableParam = {
        ...this.tableParam, 
        page: 1, 
        startTime: "", 
        endTime: "", 
        paymentMethod: "",
      };
      this.startTimDateEndTimDate = [];
      this.gettableData();
    },

    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },

    handlePayTypeChange(val) {
      if (val === '现金') {
        this.fromDate.ticketNo = '';
      }
    },

    getContractData() {
      queryContractNumber().then(res => {
        if (res.code === 1001) {
          const mapData =res.data || {};
          const list = [];
          // 遍历 Map 将其转为数组，并把 Key（支付合同编号）存入对象的 contractNumber 字段中
          for (let key in mapData) {
            if (Object.prototype.hasOwnProperty.call(mapData, key)) {
              list.push({
                contractNumber: key, // 这个 key 就是 "0", "001" 等支付合同编号
                ...mapData[key]      // 将对应的详情数据展开合并进去
              });
            }
          }
          this.contractData = list;
        } 
      });
    },
    // 3. 联动方法
    handleContractChange(val) {
      if (!Array.isArray(this.contractData)) return; 
      // 根据选中的支付合同编号（val）在数组中查找完整对象
      const contract = this.contractData.find(item => item.contractNumber === val);
      if (contract) {
        // 自动带入供应商名称、ID以及合同主体等相关字段（根据你提供的接口字段进行了对应）
        this.fromDate.supplierName = contract.supplierName || "";
        this.fromDate.supplierId = contract.supplierId || "";
        this.fromDate.contractSignSubjectId = contract.contractSigningSubjectId || "";
        this.fromDate.contractSignSubject = contract.contractSigningSubject || "";
      } else {
        // 清空
        this.fromDate.supplierName = "";
        this.fromDate.supplierId = "";
        this.fromDate.contractSignSubjectId = "";
        this.fromDate.contractSignSubject = "";
      }
    },
    DelItem(row) {
        this.$confirm("此操作将永久删除该计划付款信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          let list = [row.id];
          batchDelPlanPay(list).then(res => {
            if (res.code == 1001) {
              this.$message.success("删除成功！");
              this.gettableData();
            }
          });
        })
        .catch(() => {});
    },

    submit() {
        this.$refs.reffromDate.validate((valid) => {
          if (valid) {
              savePlanPay(this.fromDate).then(res => {
                if (res.code === 1001) {
                  this.$message.success("保存成功！");
                 } else{
                  this.$message.warning(res.codeMsg || "保存失败！");
                 }
                this.resetFromDate();
                this.gettableData();
              });
          } else {
            return false;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo-title {
  display: flex;
  justify-content: space-between;
  padding: 0.625rem 0 1.25rem 0;
}
.textline {
  line-height: 2.5rem;
  display: flex;
  > div:first-child {
    width: 6.25rem;
    text-align: right;
  }
  > div:last-child {
    width: 31.25rem;
  }
}
.table_link {
  margin-left: 0.625rem;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
.el-input,
.el-select {
  width: 15rem;
}
.success-row {
  background: #fffd87 !important;
}
</style>